export const ReviewHeader = ({ downloadRequest, onBack, onDownload, upload }) => {
  return (
    <header className="review-header px-2 pb-2">
      <div className="review-header-panel search-bar bg-green">
        <div className="row g-2 align-items-center">
          <div className="col-2 text-start">
            <button className="btn bg-beige" type="button" onClick={onBack}>
              <i className="bi bi-arrow-left" />
            </button>
          </div>

          <div className="col-8 text-center">
            <span className="review-header-label">Review Images</span>
            <h5 className="review-header-title">{upload.code}</h5>
          </div>

          <div className="col-2 text-end">
            <button className="btn bg-beige" type="button" onClick={onDownload}>
              <i className="bi bi-file-earmark-zip" />
            </button>
          </div>
        </div>

        {downloadRequest && (
          <div className="review-download-result bg-light text-dark">
            <p className="m-0">{downloadRequest.message}</p>
            {downloadRequest.downloadUrl && (
              <a className="btn bg-beige mt-2" href={downloadRequest.downloadUrl} target="_blank" rel="noreferrer">
                Open ZIP <i className="bi bi-box-arrow-up-right ms-1" />
              </a>
            )}
          </div>
        )}
      </div>
    </header>
  );
}

